import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import { SearchInput } from "components";
import { IntentList } from "./components";
import { fetchConnection } from "../../redux/actions/connectionActions";

import styles from "./styles";

class ConnectionOverview extends Component {
  signal = true;

  state = {
    isLoading: false,
    limit: 6,
    products: [],
    productsTotal: 0,
    error: null,
    search: "",
    loaded: false
  };

  async getConnections() {
    try {
      this.setState({ isLoading: true });
      await this.props.fetchConnection(this.props.match.params.connection_name);
      this.setState({ isLoading: false, loaded: true });
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error
        });
      }
    }
  }

  componentWillMount() {
    this.signal = true;
    this.getConnections();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  filterConnections = (event, val) => {
    this.setState({ search: event.target.value });
    let connectionLists = { ...this.state.connections };
    _.forEach(connectionLists, (connections, key) => {
      // Ignore fallbackIntent since it does not contain a list of connectors (it contains fallback intent data)
      if (key === "fallbackIntent") {
        return;
      }

      _.forEach(connections, connection => {
        connection.visible = _.includes(connection.connectorName.toLowerCase(), event.target.value.toLowerCase());
      });
    });
    this.setState({ connections: connectionLists });
  };

  render() {
    const { classes } = this.props;
    return (
      <DashboardLayout title="Connections" isLoading={this.state.isLoading}>
        <div className={classes.root}>
          <div className={classes.row}>
            <SearchInput
              value={this.state.search}
              className={classes.searchInput}
              onChange={this.filterConnections}
              placeholder="Search Connections"
            />
            <span className={classes.spacer} />
            <Button type="button" variant="contained" color="primary" className={classes.button}>
              Add&nbsp;Connector
            </Button>
          </div>

          <Divider className={classes.divider} />

          <div className={classes.content}>
            <div className={classes.listClass}>
              <React.Fragment>
                <h2>{this.props.connection.connectorName}</h2>
              </React.Fragment>
              {/*<ConnectionsList connections={enabled} enabled={enabled} name={"Enabled Connectors"} />*/}
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }
}

ConnectionOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  connection: PropTypes.object.isRequired,
  fetchConnection: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    connection: state.connections["connection"] ? state.connections["connection"] : {},
    skill: state.skill
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchConnection
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(ConnectionOverview))
);
